var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "200px",
    viewBox: "0 0 300 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "loan-rejected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,6.99594939 C25,3.13219323 28.1307981,0 32.007451,0 L81,0 L81,11.0064359 C81,14.31659 83.6947819,17 86.9937394,17 L99,17 L99,88.9977795 C99,98.3878466 91.3939725,106 81.9996913,106 L25,106 L25,6.99594939 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 74,
    height: 106,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,91 L75,91 C75,91 72,102.5 83.5,106 C83.5368652,106 12.4850015,106 12.4850015,106 C12.4850015,106 5.00064187e-15,106 0,92",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 83.5000143,
    height: 15,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 4,
    y: 17,
    width: 65,
    height: 46,
    rx: 7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 65,
    height: 46,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-7",
    cx: 56.5,
    cy: 40.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: -2,
    y: -2,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 35,
    width: 11,
    height: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7",
    fill: "black"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 7.95807864e-13,
    y: 7,
    width: 11,
    height: 48,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 11,
    height: 48,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 2,
    y: 4,
    width: 7,
    height: 10,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 7,
    height: 10,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loan-rejected"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    opacity: 0.3,
    transform: "translate(25.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#787878",
    x: 0,
    y: 104,
    width: 250,
    height: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(80.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy-3",
    transform: "translate(113.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-7",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#FFB132",
    cx: 18.5,
    cy: 18.5,
    rx: 18.5,
    ry: 18.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7-Copy",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#FFEEDA",
    cx: 18.5,
    cy: 18.5,
    r: 13.5666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8310541,14.3225806 C22.4245408,14.3647198 22.8641026,13.8775262 22.8641026,13.2086022 C22.8641026,12.6754138 22.4245408,12.1882202 21.8310541,12.0946237 L19.248433,12.0946237 L19.248433,10.9806452 C19.1975169,10.3538603 18.7579551,9.86666667 18.2153846,9.86666667 C17.6728141,9.86666667 17.2332523,10.3538603 17.1823362,10.9806452 L17.1823362,12.0946237 L16.1492877,12.0946237 C15.1185229,12.1882202 14.090429,13.3273976 14.0831909,14.8795699 L14.0831909,17.1075269 C14.090429,18.4490034 15.1185229,19.5881808 16.1492877,19.3354839 L17.1823362,19.3354839 L17.1823362,22.6774194 L14.5997151,22.6774194 C14.0062285,22.6352802 13.5666667,23.1224738 13.5666667,23.7913978 C13.5666667,24.3245862 14.0062285,24.8117798 14.5997151,24.9053763 L17.1823362,24.9053763 L17.1823362,26.0193548 C17.2332523,26.6461397 17.6728141,27.1333333 18.2153846,27.1333333 C18.7579551,27.1333333 19.1975169,26.6461397 19.248433,26.0193548 L19.248433,24.9053763 L20.2814815,24.9053763 C21.3122464,24.8117798 22.3403402,23.6726024 22.3475783,22.1204301 L22.3475783,19.8924731 C22.3403402,18.5509966 21.3122464,17.4118192 20.2814815,17.6645161 L19.248433,17.6645161 L19.248433,14.3225806 L21.8310541,14.3225806 Z M19.9280702,19.5156863 C20.2955655,19.5158013 20.4174089,19.6515144 20.4174089,20.0235294 L20.4174089,21.5470588 C20.4174089,21.9193038 20.2954621,22.054902 19.9280702,22.054902 L19.4387314,22.054902 L19.4387314,19.5156863 L19.9280702,19.5156863 L19.9280702,19.5156863 Z M16.9920378,16.9764706 L16.5026991,16.9764706 C16.1352037,16.9764706 16.0133603,16.8407513 16.0133603,16.4686275 L16.0133603,14.945098 C16.0133603,14.5728592 16.1353071,14.4372549 16.5026991,14.4372549 L16.9920378,14.4372549 L16.9920378,16.9764706 Z",
    id: "Shape",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-4",
    stroke: "#787878",
    mask: "url(#mask-2)",
    strokeWidth: 4,
    fill: "#F4F4F4",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Path-9",
    stroke: "#787878",
    mask: "url(#mask-4)",
    strokeWidth: 4,
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,1 L98,17",
    id: "Line",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(38.000000, 18.000000)",
    fill: "#CACACA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-35",
    x: 0,
    y: 0,
    width: 27,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-35-Copy-6",
    x: 0,
    y: 50,
    width: 21,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-35-Copy-4",
    x: 0,
    y: 60,
    width: 17,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-35-Copy",
    x: 0,
    y: 10,
    width: 37,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-35-Copy-3",
    x: 0,
    y: 30,
    width: 37,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-35-Copy-5",
    x: 0,
    y: 40,
    width: 37,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-35-Copy-2",
    x: 0,
    y: 20,
    width: 47,
    height: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67,69.5 C67.5,69.5 73.5,65.5 70.5,74 C67.5,82.5 73,83 75.5,77.5 C78,72 82,69 81,74 C80,79 79.5,83.5 83,79.5 C86.5,75.5 88.5,75 88.5,76",
    id: "Path-10",
    stroke: "#74BA2D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(41.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#FFB131",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7-Copy",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#FFEEDA",
    cx: 15,
    cy: 15,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7008547,11.6129032 C18.1820601,11.6470701 18.5384615,11.2520482 18.5384615,10.7096774 C18.5384615,10.2773626 18.1820601,9.88234072 17.7008547,9.80645161 L15.6068376,9.80645161 L15.6068376,8.90322581 C15.5655542,8.39502186 15.2091528,8 14.7692308,8 C14.3293088,8 13.9729073,8.39502186 13.9316239,8.90322581 L13.9316239,9.80645161 L13.0940171,9.80645161 C12.2582618,9.88234072 11.4246722,10.8059981 11.4188034,12.0645161 L11.4188034,13.8709677 C11.4246722,14.9586514 12.2582618,15.8823087 13.0940171,15.6774194 L13.9316239,15.6774194 L13.9316239,18.3870968 L11.8376068,18.3870968 C11.3564015,18.3529299 11,18.7479518 11,19.2903226 C11,19.7226374 11.3564015,20.1176593 11.8376068,20.1935484 L13.9316239,20.1935484 L13.9316239,21.0967742 C13.9729073,21.6049781 14.3293088,22 14.7692308,22 C15.2091528,22 15.5655542,21.6049781 15.6068376,21.0967742 L15.6068376,20.1935484 L16.4444444,20.1935484 C17.2801998,20.1176593 18.1137894,19.1940019 18.1196581,17.9354839 L18.1196581,16.1290323 C18.1137894,15.0413486 17.2801998,14.1176913 16.4444444,14.3225806 L15.6068376,14.3225806 L15.6068376,11.6129032 L17.7008547,11.6129032 Z M16.1578947,15.8235294 C16.4558639,15.8236227 16.5546559,15.9336603 16.5546559,16.2352941 L16.5546559,17.4705882 C16.5546559,17.7724085 16.4557801,17.8823529 16.1578947,17.8823529 L15.7611336,17.8823529 L15.7611336,15.8235294 L16.1578947,15.8235294 L16.1578947,15.8235294 Z M13.7773279,13.7647059 L13.3805668,13.7647059 C13.0825976,13.7647059 12.9838057,13.6546632 12.9838057,13.3529412 L12.9838057,12.1176471 C12.9838057,11.8158318 13.0826815,11.7058824 13.3805668,11.7058824 L13.7773279,11.7058824 L13.7773279,13.7647059 Z",
    id: "Shape",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(19.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.9988798 C0,17.476651 4.48395084,13 9.99727394,13 L63.0027261,13 C68.524068,13 73,17.476505 73,22.9988798 L73,57.0011202 C73,62.523349 68.5160492,67 63.0027261,67 L9.99727394,67 C4.475932,67 0,62.523495 0,57.0011202 L0,22.9988798 Z",
    id: "Rectangle-4",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#74BA2D"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-4-Copy",
    stroke: "#787878",
    mask: "url(#mask-6)",
    strokeWidth: 4,
    fill: "#FFEEDA",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy-2",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5,5,5,5",
    fill: "#FFEEDA",
    x: 11,
    y: 24,
    width: 51,
    height: 32,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,40.5 C48,36.3578644 51.3586312,33 55.5008243,33 L73,33 L73,48 L55.5008243,48 C51.3582334,48 48,44.6337072 48,40.5 L48,40.5 Z",
    id: "Rectangle-5",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#FFB131"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#787878",
    mask: "url(#mask-8)",
    strokeWidth: 4,
    xlinkHref: "#path-7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(192.832776, 57.175371) rotate(231.000000) translate(-192.832776, -57.175371) translate(187.332776, 29.675371)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    fill: "#787878",
    x: 4,
    y: 9.52127266e-13,
    width: 3,
    height: 7,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-38",
    stroke: "#787878",
    mask: "url(#mask-10)",
    strokeWidth: 4,
    fill: "#38B3DE",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-5",
    stroke: "#787878",
    mask: "url(#mask-12)",
    strokeWidth: 4,
    fill: "#FFFFFF",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#FFB132",
    x: 1.10980746,
    y: 43.8094777,
    width: 9,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-62",
    transform: "translate(161.000000, 30.000000)",
    stroke: "#787878",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-22-Copy-2",
    fill: "#F4F4F4",
    cx: 42.5,
    cy: 42.5,
    rx: 42.5,
    ry: 42.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy-4",
    transform: "translate(8.333333, 8.333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#ff8924",
    cx: 34.1650009,
    cy: 34.1650009,
    r: 34.1650009
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3465464,34.3922836 L47.2588952,26.4799348 C48.7466826,24.9921474 48.7457379,22.5905856 47.263917,21.1087647 C45.7851113,19.629959 43.3773413,19.6291921 41.8927469,21.1137865 L33.9803981,29.0261353 L26.4822628,21.5280001 C24.9976684,20.0434057 22.5898985,20.0441726 21.1110927,21.5229783 C19.6292718,23.0047992 19.6283271,25.4063609 21.1161146,26.8941484 L28.6142498,34.3922836 L21.1161146,41.8904189 C19.6283271,43.3782063 19.6292718,45.779768 21.1110927,47.2615889 C22.5898985,48.7403947 24.9976684,48.7411615 26.4822628,47.2565671 L33.9803981,39.7584319 L41.8927469,47.6707807 C43.3773413,49.1553751 45.7851113,49.1546082 47.263917,47.6758025 C48.7457379,46.1939816 48.7466826,43.7924198 47.2588952,42.3046324 L39.3465464,34.3922836 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedCheck);
export default __webpack_public_path__ + "static/media/failed-check.67db8eb6008ea05a310436399b876a0b.svg";
export { ForwardRef as ReactComponent };